import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'primereact/button';
import { SplitButton } from 'primereact/splitbutton';

import constants from 'constants/index';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { useMessageContext } from '../../context';
import CompanionCaseMessageModal from '../CreateMessage/CompanionCaseMessageModal';
import { LABELS } from '../../constants/constants';

import './MessageListHeader.scss';

function MessageListHeader({ setShowCreateModal, companionList }) {
  const { isGlobal, isFromLead, caseDetails } = useMessageContext();
  const userContext = useUserDetailsContext();

  const hasCompanion = companionList?.length > 0 && !isFromLead;
  const [showCompanionModal, setShowCompanionModal] = useState(false);

  const canWrite = userContext.getPermission('messages') === constants.permissions.WRITE;

  return (
    <div className="d-flex align-items-center mb-2">
      {isGlobal && (
        <div className="col-6 d-flex">
          <h1 className="title gray-800 mb-0 fs-3 fs-md-1">{LABELS.SECURE_MESSAGES_TITLE}</h1>
        </div>
      )}

      <div className={isGlobal ? 'col-6 d-flex justify-content-end' : 'col-12 d-flex justify-content-end'}>
        <div className="col-12 d-flex justify-content-end">
          {canWrite && (
            <>
              {!hasCompanion ? (
                <Button
                  label={LABELS.CREATE_MESSAGE}
                  className="btn-outline p-button-primary"
                  icon="pi pi-plus"
                  type="button"
                  onClick={() => setShowCreateModal(true)}
                />
              ) : (
                <SplitButton
                  label={LABELS.CREATE_MESSAGE}
                  icon="pi pi-plus"
                  onClick={() => setShowCreateModal(true)}
                  className="p-button-primary p-0"
                  model={[
                    {
                      label: LABELS.CREATE_IN_ALL_COMPANIONS,
                      command: () => setShowCompanionModal(true),
                      template: (item, options) => (
                        <div
                          className={`${options.className} message-list-menu-item`}
                          onClick={options.onClick}
                          role="menuitem"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              options.onClick(e);
                            }
                          }}
                        >
                          <div>
                            <div className="menu-item-title black-800">{item.label}</div>
                            <div className="menu-item-description black-600">{LABELS.COMPANION_DESCRIPTION}</div>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                  menuClassName="message-list-split-button-menu"
                  aria-label="Create Message Options"
                />
              )}
            </>
          )}
        </div>
      </div>

      {!isFromLead && <CompanionCaseMessageModal show={showCompanionModal} setShow={setShowCompanionModal} caseDetails={caseDetails} />}
    </div>
  );
}

MessageListHeader.propTypes = {
  setShowCreateModal: PropTypes.func.isRequired,
  companionList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      case_name: PropTypes.string,
    })
  ),
};

MessageListHeader.defaultProps = {
  companionList: [],
};

export default memo(MessageListHeader);
